module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect h-100",
    attrs: {
      "id": "modalRapportOeth"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content h-100"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body mr-3 mt-3 pt-0"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "decimal": false,
      "vmodel": _vm.declarationCalculeeOETH.NombreEmployesBoethRequis
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "NombreEmployesBoethRequis", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.NombreEmployesBoeth
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "NombreEmployesBoeth", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionBoethInterneMoinsDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionBoethInterneMoinsDeCinquanteAns", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionBoethInternePlusDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionBoethInternePlusDeCinquanteAns", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionBoethExterneMoinsDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionBoethExterneMoinsDeCinquanteAns", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionBoethExternePlusDeCinquanteAns
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionBoethExternePlusDeCinquanteAns", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.TauxEmployesBoeth
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "TauxEmployesBoeth", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": " ",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.declarationCalculeeOETH.AccordAgree) ? 'Oui' : 'Non'
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.NombreBoethManquant
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "NombreBoethManquant", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "decimal": false,
      "vmodel": _vm.declarationCalculeeOETH.CoefficientEntreprise
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "CoefficientEntreprise", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantContributionBrute
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantContributionBrute", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionEcap
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionEcap", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionSousTraitance
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionSousTraitance", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantDeductionDepenseDirecte
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantDeductionDepenseDirecte", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantContributionNetteAvantEcretement
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantContributionNetteAvantEcretement", $event)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area mb-1"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantContributionNetteApresEcretement
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantContributionNetteApresEcretement", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('input-number', {
    attrs: {
      "disabled": true,
      "vmodel": _vm.declarationCalculeeOETH.MontantBudgetAccord
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.declarationCalculeeOETH, "MontantBudgetAccord", $event)
      }
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer mt-3"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal blue",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Revenir au formulaire")])]), _vm._v(" "), (!_vm.isReadOnly) ? _c('button', {
    staticClass: "inp-button-modal valid ml-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Fermer")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Rapport financier délcaration OETH")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Renseignements principaux")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Objectif d'emploi de travailleurs handicapés")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Effectif moyen annuel de bénéficiaire de l'obligation d'emploi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Nombre BOETH total employés")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié à l'embauche de bénéficiaire(s) âgé(s) de MOINS de 50 ans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié à l'embauche de bénéficiaire(s) âgé(s) de 50 ans et PLUS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié à l'embauche de bénéficiaire(s) externe(s) âgé(s) de MOINS de 50 ans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié à l'embauche de bénéficiaire(s) externe(s) âgé(s) de 50 ans et PLUS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Taux d'emploi (en %)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head",
    attrs: {
      "title": "Mise en place d'un accord agréé d'entreprise, de groupe ou de branche sur l'emploi des personnes handicapées"
    }
  }, [_vm._v("\n                      Mise en place d'un accord agréé d'entreprise, de groupe ou de branche sur l'emploi des personnes handicapées\n                     ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Accord")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Détérmination du coefficient de votre entreprise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Nombre de BOETH manquant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Coefficiant de votre entreprise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Contribution brute avant déductions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Ce montant est à déclarer en DSN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Déductions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié aux ECAP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié à la sous-traitance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de la déduction lié aux dépenses directes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Contribution nette avant écrêtement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Ce montant est à déclarer en DSN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("Contribution nette après écrêtement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant de contribution nette après écrêtement soit le MONTANT À DÉCLARER EN DSN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "text ml-3"
  }, [_vm._v("Montant du budget de l'accord (pour les entreprises sous accord uniquement)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e099a370"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsn/modalRapportOeth/modalRapportOeth.vue.html
// module id = 9nym
// module chunks = 2